// $(function() {
//   $('.quickview_button').on('click', function(){
//     $('.product_section_popup').removeClass('hidden');
//   });
//   $('[data-popup-close]').on('click', function(){
//     $('.product_section_popup').addClass('hidden')
//   })

// });

 // $(".open_popup").click(function () {
 //   $(this).parent(".product_section_popup").children(".popup_body").addClass("popup_body_show");
 //   });
 // $(".popup_close").click(function () {
 //   $(".popup_body").removeClass("popup_body_show");
 //   });
 // $(".popup_back").click(function () {
 //   $(".popup_body").removeClass("popup_body_show");
 //   });
jQuery(document).ready(function($) {
          // Add the custom_Sticky class to section__header when hovering over the specific li elements
            $("li.header-menu__list-item.h-full").hover(function() {
                $(".section__header").addClass("bg_header");
            }, function() {
                $(".section__header").removeClass("bg_header");
            });
    });

$(function(){
  $('.quickview_button').on('click', function(){
    $('.product_section_popup').addClass('quickViewOpen');
  });
   $(".popup-close").click(function () {
     $(".product_section_popup").removeClass("quickViewOpen");
    });
});





// $(function() {
//   const sectionHeader = document.querySelector('.section__header');
//   let isSticky = false;

//   window.addEventListener('scroll', () => {
//     const currentScrollPos = window.pageYOffset;

//     if (currentScrollPos > 0 && !isSticky) {
//       sectionHeader.classList.add('custom_Sticky');
//       isSticky = true;
//     } else if (currentScrollPos === 0) {
//       sectionHeader.classList.remove('custom_Sticky');
//       isSticky = false;
//     }
//   });
// })

jQuery(document).ready(function($) {

    });
  $(document).ready(function() {
  $('.OnNext-Menu').on('click', function() {
    var ownCustomClassElement = $(this).closest('.menu-drawer__navigation').find('.OwnCustomClass');
    var CustomClassElement = $(this).closest('.OwnGivenClass').find('.MenuMobile-custom');
    ownCustomClassElement.addClass('customSlide');
    CustomClassElement.addClass('MobileDesign');
  });


     $('.Onclick-Back').on('click', function() {
    $('.OwnCustomClass').removeClass('customSlide');
  $('.MenuMobile-custom').removeClass('MobileDesign');
      $('.MenuMobile-custom').removeAttr('open');
      });
 
    $(".InnerSubmenu").click(function() {
      $(".Menu_mobileCustomization").addClass("InnerMenu-Customization");
      $(".ShowNext-slide").addClass("AllAbout-MobileMenu");
    });

    $(".Onclick-next").click(function() {
    $(".Menu_mobileCustomization").removeClass("InnerMenu-Customization");
      $(".ShowNext-slide").removeClass("AllAbout-MobileMenu");
  });

  //   $(".OnClick-open").click(function(){
  //      $(".header--horizontal").addClass("Opening");
  //      $("body").addClass("BodyDesign");
  //        $(".section__header").addClass("custom_Sticky");
  //       $("body.has-modal").css("overflow", "hidden");
  //  });

  // $('.OnClick-close').click(function() {
  // $('#MenuDrawer').removeAttr('open');
  //   $(".header--horizontal").removeClass("Opening");
  //   $("body").removeClass("BodyDesign");
  //   $(".section__header").removeClass("custom_Sticky");
  //   $("body.has-modal").css("overflow", "visible");
  //   });

  });
    
